import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import LandingPage from "@/pages/LandingPage";
import AboutPage from "@/pages/AboutPage";
import AdminPage from "@/pages/AdminPage";
import IntakePage from "@/pages/IntakePage";
import ChatWidget from "@/components/ChatWidget";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/intake" element={<IntakePage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
        <ChatWidget />
        <Toaster position="top-center" richColors closeButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
